export default __webpack_public_path__ + "static/media/tone-of-voice.c58bb718.svg";